'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponentsReactiveGrid = require('styled-components-reactive-grid');

var _decisivUiUtils = require('decisiv-ui-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  active: function active(_ref) {
    var theme = _ref.theme;
    return '\n    background-color: ' + theme.colors.base.selectableActive + ';\n    pointer-events: none;\n    span {\n      color: ' + theme.colors.base.linkHover + ';\n    }\n  ';
  },
  disabled: function disabled() {
    return '\n    opacity: 0.5;\n    pointer-events: none;\n  ';
  }
};

var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  cursor: pointer;\n  transition: background 200ms ease;\n  &:hover {\n    background-color: ' + theme.colors.base.selectableHover + ';\n    span {\n      color: ' + theme.colors.base.linkHover + ';\n      text-decoration: underline;\n    }\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      linkHover: _propTypes2.default.string.isRequired,
      selectableActive: _propTypes2.default.string.isRequired,
      selectableHover: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var ContainerSelectable = (0, _decisivUiUtils.buildStyledComponent)('ContainerSelectable', _styledComponentsReactiveGrid.Container, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

exports.default = ContainerSelectable;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/ContainerSelectable/index.js
// module id = 1560
// module chunks = 2